import { Button, ExclusiveChoice, ModalPanel, Title } from "dash-styled"
import React, { FC, useCallback, useState } from "react"
import {
    AppWorkerRole,
    AppWorkerRoles,
    toDisplayText
} from "../../../../../../../Models/API/AppWorkerRole"
import { Labeled } from "../../../../../../Common/Render/Common/Labeled/Labeled"

interface AppWorkerRoleChangeModalProps {
    title: string
    currentRole: AppWorkerRole
    isSaving: boolean
    onClose: () => void
    onSubmit: (role: AppWorkerRole) => void
}

export const AppWorkerRoleChangeModal: FC<AppWorkerRoleChangeModalProps> = ({
    title,
    currentRole,
    isSaving,
    onClose,
    onSubmit
}) => {
    const [role, setRole] = useState<AppWorkerRole>(currentRole)
    const handleSubmit = useCallback(() => onSubmit(role), [onSubmit, role])

    return (
        <ModalPanel onClose={onClose} className="max-w-2xl w-full">
            <Title variant="heading2" weight="semibold" component="h2">
                {title}
            </Title>
            <Labeled label="Role" errors={[]}>
                <ExclusiveChoice
                    withPanel={false}
                    choices={[...AppWorkerRoles]}
                    selectedIndex={
                        role === undefined ? -1 : AppWorkerRoles.indexOf(role)
                    }
                    renderChoice={toDisplayText}
                    onClick={index => setRole(AppWorkerRoles[index])}
                />
            </Labeled>
            <div className="flex justify-center">
                <Button color="plain" onClick={onClose} className="w-48 mr-4">
                    Cancel
                </Button>
                <Button
                    disabled={isSaving || role === currentRole}
                    className="w-48"
                    onClick={handleSubmit}
                >
                    {isSaving ? "Updating..." : "Update"}
                </Button>
            </div>
        </ModalPanel>
    )
}
